<template>
  <div class="chart-container">
    <div
      ref="chartRef"
      class="chart"
    />
  </div>
</template>

<script setup>
import * as echarts from 'echarts'
import { onMounted, onUnmounted, ref, watch } from 'vue'

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
  },
})

const chartRef = ref(null)
const chartInstance = ref(null)

const initChart = () => {
  if (chartInstance.value) {
    chartInstance.value.dispose()
  }

  const chartDom = chartRef.value
  if (chartDom) {
    chartInstance.value = echarts.init(chartDom)

    const option = {
      title: {
        text: props.chartTitle,
        left: 'center',
        textStyle: {
          fontSize: 16,
          fontWeight: 'bold',
        },
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)',
      },
      legend: {
        type: 'scroll', // Enable scrolling for legend
        orient: 'vertical',
        right: 120,
        top: 'middle',
        pageIconColor: '#999',
        pageTextStyle: {
          color: '#333',
        },
        height: '75%', // Limit height to trigger scrolling if needed
      },
     
      series: [
        {
          name: props.chartTitle,
          type: 'pie',
          radius: ['20%', '60%'],
          center: ['35%', '55%'],
          roseType: 'area',
          itemStyle: {
            borderRadius: 8,
          },
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}',
            fontSize: 12,
          },
          labelLine: {
            show: true,
            length: 15,
            length2: 10,
          },
          data: props.chartData,
        },
      ],
    }

    chartInstance.value.setOption(option)
    window.addEventListener('resize', chartInstance.value.resize)
  }
}

onMounted(initChart)

onUnmounted(() => {
  if (chartInstance.value) {
    window.removeEventListener('resize', chartInstance.value.resize)
    chartInstance.value.dispose()
  }
})

watch(() => props.chartData, initChart, { deep: true })
</script>

<style scoped>
.chart-container {
  position: relative;
  inline-size: 100%;
  block-size: 450px; /* Adjust height as needed */
  overflow: hidden;
}

.chart {
  inline-size: 100%;
  block-size: 100%;
}
</style>
